import { useEffect, useRef } from 'react';

import isFunction from 'utils/function';

const useUpdateEffect = <D extends any[]>(
    effect: () => void,
    dependencies: D,
) => {
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current === true) {
            isFirstRender.current = false;
        } else if (isFunction(effect)) {
            effect();
        }
    }, dependencies);
};

export default useUpdateEffect;
